import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/account/')) return null;

  return (
    <footer style={{ backgroundColor: '#1E3A2E' }} className="border-t border-[#2D5040]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-3">
              <div className="font-semibold text-white text-base">Granted</div>
              <div
                style={{ fontSize: '10px', color: '#C9A450', letterSpacing: '0.1em' }}
                className="font-medium uppercase"
              >
                by Saquarius Client Services LLC
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
              Rhode Island's premier grant funding platform. Connecting nonprofits and small
              businesses with verified resources and expert writers.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h3 className="text-xs font-semibold text-white uppercase tracking-wider mb-4">
              Platform
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/grants"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Find Grants
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Pricing Plans
                </Link>
              </li>
              <li>
                <Link
                  to="/find-a-writer"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Find a Writer
                </Link>
              </li>
              <li>
                <Link
                  to="/apply-writer"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Become a Writer
                </Link>
              </li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h3 className="text-xs font-semibold text-white uppercase tracking-wider mb-4">
              Account
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/account/signup"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Create Account
                </Link>
              </li>
              <li>
                <Link
                  to="/account/signin"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Sign In
                </Link>
              </li>
              <li>
                <Link
                  to="/account/billing"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Billing
                </Link>
              </li>
              <li>
                <a
                  href="https://www.saquariusservices.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  About Saquarius ↗
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-xs font-semibold text-white uppercase tracking-wider mb-4">
              Legal
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
            <p className="text-xs text-gray-600 mt-5 leading-relaxed">
              Payments via Stripe (test mode). No live charges are processed.
            </p>
          </div>
        </div>

        <div className="border-t border-[#2D5040] pt-6 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-xs text-gray-500">
            © 2026 Saquarius Client Services LLC. All rights reserved.
          </p>
          <p className="text-xs text-gray-600">Granted · Providence, Rhode Island</p>
        </div>
      </div>
    </footer>
  );
}
